import { GlSprintf, GlLink } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { __ } from '~/locale';
import { BLOB_RENDER_ERRORS, BLOB_RENDER_EVENT_LOAD, BLOB_RENDER_EVENT_SHOW_SOURCE } from './constants';
export default {
    name: 'BlobContentError',
    components: {
        GlSprintf,
        GlLink
    },
    props: {
        viewerError: {
            type: String,
            required: true
        },
        blob: {
            type: Object,
            required: false,
            default: ()=>({})
        }
    },
    emits: [
        BLOB_RENDER_EVENT_LOAD,
        BLOB_RENDER_EVENT_SHOW_SOURCE
    ],
    computed: {
        notStoredExternally () {
            return this.viewerError !== BLOB_RENDER_ERRORS.REASONS.EXTERNAL.id;
        },
        renderErrorReason () {
            const defaultReasonPath = Object.keys(BLOB_RENDER_ERRORS.REASONS).find((reason)=>BLOB_RENDER_ERRORS.REASONS[reason].id === this.viewerError);
            const defaultReason = BLOB_RENDER_ERRORS.REASONS[defaultReasonPath].text;
            return this.notStoredExternally ? defaultReason : defaultReason[this.blob.externalStorage || 'default'];
        },
        renderErrorOptions () {
            const load = {
                ...BLOB_RENDER_ERRORS.OPTIONS.LOAD,
                condition: this.shouldShowLoadBtn
            };
            const showSource = {
                ...BLOB_RENDER_ERRORS.OPTIONS.SHOW_SOURCE,
                condition: this.shouldShowSourceBtn
            };
            const download = {
                ...BLOB_RENDER_ERRORS.OPTIONS.DOWNLOAD,
                href: this.blob.rawPath
            };
            return [
                load,
                showSource,
                download
            ];
        },
        shouldShowLoadBtn () {
            return this.viewerError === BLOB_RENDER_ERRORS.REASONS.COLLAPSED.id;
        },
        shouldShowSourceBtn () {
            return this.blob.richViewer && this.blob.renderedAsText && this.notStoredExternally;
        }
    },
    errorMessage: __('Content could not be displayed: %{reason}. Options to address this: %{options}.')
};
